// @flow
import { useLocale } from "./useI18n";
import { useMemo } from "react";

/**
 * Generates the key that is used in the modular ui reducer of redux
 */
export const useModularUIKey = (modelKey: string, url: string): string => {
  const locale = useLocale();
  return useMemo(
    () => `${modelKey}(${url.split("?")[0]})(${locale})`,
    [modelKey, url, locale],
  );
};
